import React from "react";
import Translate from "react-translate-component";
import FormattedAsset from "../../Utility/FormattedAsset";
export const BondCreateOffer = ({
  op
}) => {
  return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Translate, {
    component: "span",
    content: "proposal.bond_create_offer"
  }), "\xA0", /*#__PURE__*/React.createElement(FormattedAsset, {
    style: {
      fontWeight: "bold"
    },
    amount: op[1].amount.amount,
    asset: op[1].amount.asset_id
  }));
};